import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../../store/AppStore'
import { connect } from 'react-redux'
import DtoSource from '../../dto/DtoSource'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { filter, find, orderBy } from 'lodash'
import HomeAction from '../../../home/actions/HomeAction'
import i18n from 'simple-react-i18n'
import UUID from 'uuid'
import AdministrationAction from '../../actions/AdministrationAction'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import { makeStyles } from '@material-ui/core'

class SourceInformationsPanel extends Component {

	constructor(props) {
		super(props)
	}

	componentWillMount() {
		AppStore.dispatch(HomeAction.setTitle(i18n.sources))
		if (!this.props.sources.length) {
			AppStore.dispatch(AdministrationAction.fetchSources())
		}
	}

	openUrl = (url) => {
		window.open(url, '_blank')
	}

	createItem = (source, classes) => {
		return (
			<div key={ UUID.v4() }>
				<ListItem alignItems='flex-start' onClick={ () => this.openUrl(source.url) }>
					<ListItemAvatar>
						<div className='valign-wrapper'>
							<img src={ source.logo } className='width-40'/>
						</div>
					</ListItemAvatar>
					<ListItemText
						className={ classes.itemStyle }
						primary={ source.name }
						secondary={
							<p>
								{ source.comment }
							</p>
						}
					/>
				</ListItem>
				<Divider variant='inset' component='li'/>
			</div>
		)
	}

	getSources = (classes) => {
		if (this.props.sources.length) {
			const aquasysName = 'Aquasys'
			const listWithoutAquasys = filter(this.props.sources, (o) => {
				return o.name !== aquasysName
			})
			const list = orderBy(listWithoutAquasys, ['name'], ['asc']).map((source) => {
				return this.createItem(source, classes)
			})

			return (
				<List>
					{ list }
				</List>
			)
		}
		return null
	}

	getAquasysSource = (classes) => {
		if (this.props.sources.length) {
			const aquasysName = i18n.aquasys
			const aquasysSource = find(this.props.sources, (o) => {
				return o.name === aquasysName
			})
			return (
				<List>
					{ this.createItem(aquasysSource, classes) }
				</List>
			)
		}
		return null
	}

	render() {
		const classes = makeStyles(() => ({
			itemStyle: {
				fontSize: '25px',
				fontWeight: 'bold'
			}
		}))
		return (
			<div className='row'>
				<div className='col s10 offset-s1'>
					<div className='row card'>
						{ this.getAquasysSource(classes) }
					</div>
					<div className='row card'>
						{ this.getSources(classes) }
					</div>
				</div>
			</div>
		)
	}
}

SourceInformationsPanel.propTypes = {
	sources: PropTypes.arrayOf(PropTypes.objectOf(DtoSource))
}
const mapStateToProps = store => {
	return {
		sources: store.AdministrationReducer.sources
	}
}

export default connect(mapStateToProps)(SourceInformationsPanel)



// WEBPACK FOOTER //
// ./src/administration/components/sourcesInformations/SourceInformationsPanel.js